import { Component, Input, OnInit } from '@angular/core';
import { CalculAchatCorporatifAvecAvantage } from '../../../models/calcul-achat-corporatif-avec-avantage.model';
import { MonthEnum } from '../../../enums/month.enum';


@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
  standalone: false,
})
export class VehiclesComponent implements OnInit {

  public yearCardIsCollapsed = {};
  public scenarioIsCollapsed = {
    'achat': true,
    'location': true,
    'location_achat': true,
  };

  @Input()
  public calculAchatCorporatifAvecAvantage: CalculAchatCorporatifAvecAvantage = {
    societeInscriteAuxTaxes: true,
    salarieCotisationAssuranceEmploi: true,
    situationVehicule: 'aucune',
    methodeDePaiementAvantagesImposables: 'dividende',
    salaire: {
      masseSalarialeEntreprise: 200000,
      societeEmployeurPublic: false,
      cinquantePourcentSecteurPrimaireOuManufacturier: false,
    },
    moisVehiculeMisADispositionPourEmployee: MonthEnum.April,
    montantSubventionProvinciale: 0,
    montantSubventionFederale: 0,
    years: [
      {
        year: 2020,
        tauxImpositionSociete: 15,
        revenuAnnuelTotalDuParticulier: 60000,
        salaireAnnuelDuParticulier: 54000,
        coutPermisConduire: 120,
        coutImmatriculation: 260,
        coutStationnement: 0,
        avantageImposableStationnement: 0,
        coutAssuranceAchatAvecTaxes: 1000,
        coutAssuranceLocationAvecTaxes: 1000,
        coutEntretienReparationLocationAvecTaxes: 0,
        coutEntretienReparationAchatAvecTaxes: 0,
        coutElectriciteSansTaxes: 0,
        coutEssenceAvecTaxes: 2200,
        nombreDeKilometresTotauxParcouruParAnnee: 20000,
        nombreDeKilometresParcouruPourAffaireParAnnee: 10000,
      },
    ],
    scenarioAchat: {
      coutAchatVehiculeSansTaxes: 36000,
      montantDesMensualites: 0,
      tauxInteretAnnuel: 0.04,
      montantEmprunteSiAucuneRenonciationSubventionFederale: 2000,
      utilisationPrevuePlusDe10PourcentActiviteCommerciale: false,
    },
    scenarioLocation: {
      mensualitePremiereLocation: 500,
      nombreDeMoisPremiereLocation: 48,
      deuxiemeLocationDansLaPeriode: false,
      mensualitePourDeuxiemeLocation: 500,
    },
    scenarioLocationRachat: {
      nombreDeMoisLocation: 48,
      coutRachat: 22000,
    },
  };

  ngOnInit(): void {
  }

  getYearCardStyle(year: number) {
    return {
      'card-collapsed': this.isYearCardCollapsed(year),
    };
  }

  isYearCardCollapsed(year: number) {
    if (this.yearCardIsCollapsed.hasOwnProperty(year) === false) {
      return false;
    }

    return this.yearCardIsCollapsed[year];
  }

  toggleYearCardCollapse(year: number) {
    // debugger;
    if (this.yearCardIsCollapsed.hasOwnProperty(year) === false) {
      this.yearCardIsCollapsed[year] = true;
      return;
    }

    this.yearCardIsCollapsed[year] = !this.yearCardIsCollapsed[year];
  }

  getScenarioStyle(scenario: string) {
    return {
      'card-collapsed': this.isScenarioCollapsed(scenario),
    };
  }

  isScenarioCollapsed(scenario: string) {
    if (this.scenarioIsCollapsed.hasOwnProperty(scenario) === false) {
      return false;
    }

    return this.scenarioIsCollapsed[scenario];
  }

  toggleScenarioCollapse(scenario: string) {
    // debugger;
    if (this.scenarioIsCollapsed.hasOwnProperty(scenario) === false) {
      this.scenarioIsCollapsed[scenario] = true;
      return;
    }

    this.scenarioIsCollapsed[scenario] = !this.scenarioIsCollapsed[scenario];
  }

  getFirstYear(): number {
    if (this.calculAchatCorporatifAvecAvantage?.years.length === 0) {
      return 2020;
    }

    return this.calculAchatCorporatifAvecAvantage.years[0].year;
  }

  getLastYear(): number {
    if (this.calculAchatCorporatifAvecAvantage.years.length === 0) {
      return 2020;
    }

    return this.calculAchatCorporatifAvecAvantage.years[this.calculAchatCorporatifAvecAvantage.years.length - 1].year;
  }

  getLastYearObject() {
    if (this.calculAchatCorporatifAvecAvantage.years.length === 0) {
      return undefined;
    }

    return this.calculAchatCorporatifAvecAvantage.years[this.calculAchatCorporatifAvecAvantage.years.length - 1];
  }

  addYear() {
    const lastYear = this.getLastYear();

    if (this.calculAchatCorporatifAvecAvantage.years.length === 0) {
      this.calculAchatCorporatifAvecAvantage.years.push({
        year: 2020,
        tauxImpositionSociete: 15,
        revenuAnnuelTotalDuParticulier: 60000,
        salaireAnnuelDuParticulier: 60000,
        coutPermisConduire: 120,
        coutImmatriculation: 260,
        coutStationnement: 0,
        avantageImposableStationnement: 0,
        coutAssuranceAchatAvecTaxes: 1000,
        coutAssuranceLocationAvecTaxes: 1000,
        coutEntretienReparationLocationAvecTaxes: 0,
        coutEntretienReparationAchatAvecTaxes: 0,
        coutElectriciteSansTaxes: 0,
        coutEssenceAvecTaxes: 2200,
        nombreDeKilometresTotauxParcouruParAnnee: 20000,
        nombreDeKilometresParcouruPourAffaireParAnnee: 10000,
      });
      return;
    }

    const year = { ...this.calculAchatCorporatifAvecAvantage.years[this.calculAchatCorporatifAvecAvantage.years.length - 1] };

    year.year = year.year + 1;

    this.calculAchatCorporatifAvecAvantage.years.push(year);
  }

  removeLastYear() {
    if (this.calculAchatCorporatifAvecAvantage?.years.length === 0) {
      return;
    }

    this.calculAchatCorporatifAvecAvantage.years.pop();
  }

  getNumberOfMonthsInCalculation() {
    return (this.getLastYear() - this.getFirstYear()) * 12 - this.calculAchatCorporatifAvecAvantage.moisVehiculeMisADispositionPourEmployee.valueOf() + this.getLastYearObject()?.moisAPartirDuquelOnTermineLesCalculs;
  }
}
